export default "__VITE_ASSET__CbX3CTQC__"